<template>
  <section
    class="default-navbar"
    id="top-navbar-view"
    :class="{
      beforeScroll: scrollPosition < 0,
      afterScroll: scrollPosition > 0.5,
    }"
  >
    <el-row type="flex" align="middle">
      <el-col :lg="6" :xl="7">
        <ul class="navbar-logo-grid">
          <li>
            <div class="logo" v-if="!isHospitalUser">
              <router-link to="/all-cases">
                <img
                  src="@/assets/images/dlw-medical-group-logo.svg"
                  alt="medical-group-logo"
                  class="img-fluid"
                />
              </router-link>
            </div>
          </li>
          <li class="pl-20">
            <div class="menu-toggle-button cursor">
              <span class="el-dropdown-link" @click="menuNavigation = true">
                <img
                  src="../assets/images/dashboard-icon.svg"
                  alt="dashboard-icon"
                />
              </span>
            </div>
          </li>
          <li>
            <div class="title">
              <Title></Title>
            </div>
          </li>
        </ul>
      </el-col>
      <el-col :lg="14" :xl="11">
        <div class="navbar-filters">
          <div class="quick-navigation">
            <ul>
              <li
                v-if="
                  globalRouteNames.indexOf($route.name) == -1 &&
                  hasPermission('case_reports', 'view')
                "
              >
                <router-link to="/global-search" class="bg-blue">
                  <span class="global-search-d-flex">
                    <span class="mr-8">Global</span>
                    <span>
                      <img
                        class="inactive"
                        src="../assets/images/icons/global-search-icon-new.svg"
                        alt="icon"
                      />
                    </span>
                  </span>
                </router-link>
              </li>
              <li>
                <router-link
                  to="/all-cases"
                  :class="{
                    active: isRouteActive([
                      'AllCases',
                      'ActiveCases',
                      'PendingCases',
                      'CompleteCases',
                      'ArchiveCase',
                      'CaseView',
                      'Case-Information-Update',
                      'NewCase',
                      'EMRNotSend',
                      'ReleasePending',
                      'RejectedCases',
                      'ReplacedInsurance',
                      'RequiresAttentionCases',
                    ]),
                  }"
                  >All Cases</router-link
                >
              </li>
              <li v-if="hasPermission('orders', 'view')">
                <router-link
                  to="/all-orders"
                  :class="{
                    active: isRouteActive([
                      'AllOrders',
                      'ActiveOrders',
                      'CompleteOrders',
                      'Order-Information',
                    ]),
                  }"
                  >Orders</router-link
                >
              </li>
              <li v-if="hasPermission('global_search', 'view')">
                <router-link
                  to="/all-send-outs"
                  :class="{
                    active: isRouteActive([
                      'allSendOuts',
                      'ActiveSendOuts',
                      'CompleteSendOuts',
                      'SendoutsInformation',
                      'SendOutsView',
                    ]),
                  }"
                  >Sendouts</router-link
                >
              </li>
              <li v-if="hasPermission('billing', 'view')">
                <router-link
                  to="/all-billing-cases/pending"
                  :class="{
                    active: isRouteActive([
                      'AllPendingBilledCases',
                      'BilledCases',
                      'ClientBilledCases',
                      'ExceptionBilledCases',
                      'OnholdBilledCases',
                      'BilledExceptionBilledCases',
                      'BilledPatientBilledCases',
                      'CodingCases',
                      'ExceptionResolvedCases',
                      'ExceptionReviewedCases',
                    ]),
                  }"
                  >Billing</router-link
                >
              </li>
            </ul>
          </div>
          <div>
            <navFilters></navFilters>
          </div>
        </div>
      </el-col>
      <el-col :lg="4" :xl="6">
        <div
          class="location_grid"
        >
          <div class="new-case-button">
            <el-select
              v-model="selectedLab"
              placeholder="Select Lab"
              @change="setSelectedLab"
            >
              <el-option
                v-for="(lab, index) in this.getUserAllowedLabs"
                :key="index"
                :label="lab.name"
                :value="lab._id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <ul class="navbar-action-grid">
          <li
            v-if="
              casesRouteNames.indexOf($route.name) == -1 &&
              globalRouteNames.indexOf($route.name) == -1
            "
          >
            <div class="navbar-back-navigation" v-if="!$route.query.expire">
              <GoBackButton></GoBackButton>
            </div>
          </li>
          <li>
            <div class="avatar profile-dropdown">
              <el-dropdown
                popper-class="profile-dropdown-new"
                placement="bottom-start"
              >
                <el-button>
                  <el-avatar
                    :size="35"
                    width="30"
                    height="30"
                  >
                    <img class="profile-image" src="@/assets/images/default-user.svg" /></el-avatar
                ></el-button>
                <template #dropdown>
                  <el-dropdown-menu class="login-profile" placement>
                    <div id="profile">
                      <div class="profile-pop">
                        <!-- <div class="dropdown-profile-img" v-if="snapUrl">
                          <el-avatar :size="100">
                            <img
                              :src="snapUrl"
                              alt="profile"
                              class="profile-image"
                            />
                          </el-avatar>
                        </div> -->
<!-- 
                        <div class="edit-icon">
                          <img
                            src="@/assets/images/icons/profile/edit-profile-pic.svg"
                            alt="edit-pic"
                          />
                        </div> -->
                        <!-- <el-dropdown-item class="profile-content">
                          <h3 v-if="getAuthenticatedUser" class="value">
                            {{ this.getProfileUserNameForHeader }}
                          </h3>
                          <p>
                            {{
                              userTypeMap[this.getProfileDesignationForHeader]
                            }}
                          </p>
                        </el-dropdown-item> -->
                        <div class="username">
                          <!-- <el-button @click="viewProfile()">
                            <div>
                              <ul>
                                <li>
                                  <span
                                    ><img
                                      src="@/assets/images/icons/profile/user-profile.svg"
                                      alt="user-profile"
                                  /></span>
                                  <h4>View Profile</h4>
                                </li>
                              </ul>
                            </div>
                          </el-button> -->
                          <!-- <el-button @click="updatePassword()">
                            <ul>
                              <li>
                                <span
                                  ><img
                                    src="@/assets/images/icons/profile/password.svg"
                                    alt="right-arrow"
                                /></span>
                                <h4>Update Password</h4>
                              </li>
                            </ul>
                          </el-button> -->
                          <el-button @click="logOut()">
                            <ul>
                              <li>
                                <span
                                  ><img
                                    class="logout"
                                    src="@/assets/images/icons/profile/log-out.svg"
                                    alt="log-out"
                                    style="padding-top: 5px;"
                                /></span>
                                <h4>Log Out</h4>
                              </li>
                            </ul>
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </li>
        </ul>
      </el-col>
    </el-row>
    <!-- Mega Dropdown UI -->
    <div id="navigation-toggle">
      <el-drawer v-model="menuNavigation" size="100%" direction="ttb">
        <span>
          <div class="menu-inner-view">
            <el-row>
              <el-col :span="8">
                <ul class="navbar-logo-grid">
                  <li>
                    <div class="logo">
                      <img
                        src="@/assets/images/dlw-medical-group-logo.svg"
                        alt="medical-group-logo"
                        class="img-fluid"
                      />
                    </div>
                  </li>
                  <li class="pl-20">
                    <div class="menu-toggle-button cursor">
                      <span
                        class="el-dropdown-link"
                        @click="menuNavigation = false"
                      >
                        <img
                          src="../assets/images/dashboard-icon.svg"
                          alt="dashboard-icon"
                        />
                      </span>
                    </div>
                  </li>
                  <li>
                    <div class="menu-title">
                      <h3 class="name">Menu</h3>
                    </div>
                  </li>
                </ul>
              </el-col>
              <el-col :span="13" class="menu-search"> </el-col>
              <el-col :span="3" class="drawer-close-button">
                <el-button
                  size="medium"
                  class="el-white"
                  type="info"
                  plain
                  @click="menuNavigation = false"
                >
                  <img
                    src="@/assets/images/icons/cases/close-btn.svg"
                    alt="icon"
                    width="30"
                /></el-button>
              </el-col>
            </el-row></div
        ></span>
        <NavigationMenu></NavigationMenu>
      </el-drawer>
    </div>
  </section>
</template>

<script>
import NavigationMenu from "@/components/NavigationMenu";
import navFilters from "@/components/navbarFilter/index.vue";
import Title from "@/components/navbar/Title";
import GoBackButton from "@/components/navbar/GoBack";
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import userConstants from "@/config/constants/userConstants";
export default {
  name: "topbar-default",
  components: {
    NavigationMenu,
    navFilters,
    Title,
    GoBackButton,
  },
  mixins: [UserPermissionsHelper],
  data() {
    return {
      scrollPosition: null,
      menuNavigation: false,
      snapUrl: "",
      globalRouteNames: ["GlobalSearch"],
      casesRouteNames: [
        "AllCases",
        "ActiveCases",
        "PendingCases",
        "CompleteCases",
        "ArchiveCase",
        "AllOrders",
        "ActiveOrders",
        "CompleteOrders",
        "AllBillingCase",
        "ActiveBillingCase",
        "PendingBillingCase",
        "CompleteBillingCase",
        "allResults",
        "ActiveResults",
        "ToStartResults",
        "CompleteResults",
        "ArchiveResults",
        "ProcessingResults",
        "FailedResults",
        "AllPhysicians",
        "ActivePhysicians",
        "InActivePhysicians",
        "AllHospitals",
        "ActiveHospitals",
        "InActiveHospitals",
        "QCChatResults",
        "ToStartQCChartResults",
        "CompleteQCChartResults",
        "batchList",
        "icd10codes",
        "allSendOuts",
        "allReceivedSendOuts",
        "ActiveReceivedSendOuts",
        "CompleteReceivedSendOuts",
        "LabInformation",
        "userAccounts",
        "ActiveUserAccounts",
        "InActiveUserAccounts",
        "LabDocumentFolders",
        "casesLogs",
        "ordersLogs",
        "archive",
        "ReportsList",
        "AllApprovalPendingCases",
        "ActiveApprovalPendingCases",
        "PendingApprovalPendingCases",
        "CompleteApprovalPendingCases",
        "RejectedApprovalPendingCases",
        "QCChartReport",
        "AllLabListing",
        "EmailLogs",
        "TsiReports",
        "ActiveSendOuts",
        "CompleteSendOuts",
        "PulmonaryReportsList",
        "AllInstrumentTestConfig",
        "BloodQCLevel",
        "BloodQCchart",
        "ArchiveDataCases",
        "ArchiveDataOrders",
        "bloodResult",
        "allBulkAccession",
        "LabdaqPendingOrders",
        "LabdaqPendingResults",
        "ValidationCases",
        "ValidationOrders",
        "ValidationEMROrders",
        "ActiveValidationCases",
        "PendingValidationCases",
        "CompleteValidationCases",
        "ArchiveValidationCases",
        "ActiveValidations",
        "CompleteValidations",
        "ArchiveValidations",
        "ActiveValidationEMROrders",
        "ArchiveValidationEMROrders",
        "CompleteValidationEMROrders",
        "AllPendingBilledCases",
        "BilledCases",
        "ClientBilledCases",
        "ExceptionBilledCases",
        "OnholdBilledCases",
        "BilledExceptionBilledCases",
        "BilledPatientBilledCases",
        "CodingCases",
        "NewReportCases",
        "ExceptionResolvedCases",
        "ExceptionReviewedCases",
        "CommercialInsuranceSettings",
        "CommercialInsuranceFacilitySettings"
      ],
      userTypeMap: userConstants.USER_TYPE_MAP,
      selectedLab: "",
    };
  },

  computed: {
    ...mapGetters("auth", [
      "getAuthenticatedUser",
      "getUserPrimaryLabId",
      "getUserAllowedLabs",
    ]),
    ...mapGetters("profile", [
      "getProfileData",
      "getProfileUserNameForHeader",
      "getProfileDesignationForHeader",
    ]),
    ...mapGetters("labs", ["getAllLabs"]),
    isRouteActive() {
      return (routeNames) =>
        routeNames.indexOf(this.$route.name) != -1 ? true : false;
    },
  },
  async mounted() {
    // Scroll
    window.addEventListener("scroll", this.updateScroll);
    this.toggleBodyClass("removeClass", "navbarTypeTwo");
    if (this.getUserPrimaryLabId) {
      this.selectedLab = this.getUserPrimaryLabId;
    }
    await this.$store.dispatch("labs/fetchAllLabs");
  },
  watch: {
    $route() {
      this.menuNavigation = false;
    },
  },
  methods: {
    setSelectedLab() {
      let selectedLabDetails = this.getUserAllowedLabs.find(
        (lab) => lab._id == this.selectedLab
      );
      this.$store.dispatch("auth/setPrimaryLabDetails", selectedLabDetails);
      window.location.reload();
    },
    async logOut() {
      await this.$store.dispatch("globalReset");
      this.$router.push("/signin");
    },
    // Scroll
    async updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    updatePassword() {
      this.$router.push("/update-password");
    },
    viewProfile() {
      this.$router.push("/user-profile");
    },
    async toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
};
</script>

<style lang="scss">
.default-navbar {
  padding: 5px 30px 7px 30px;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  .navbar-logo-grid {
    display: flex;
    align-items: center;
    li {
      &:not(:last-child) {
        margin-right: 15px;
      }
      .logo {
        img {
          width: 150px;
          margin-top: 5px;
        }
      }
      .menu-toggle-button {
        margin-bottom: -5px;
        .el-dropdown-menu {
          padding: 0;
        }
      }
      .nav-title {
        h3 {
          color: #363636;
          font-size: 1em;
          font-weight: 600;
          white-space: nowrap;
          @media (min-width: 1200px) and (max-width: 1700px) {
            font-size: 0.88em !important;
          }
        }
      }
    }
    .menu-title {
      color: #273480;
      text-transform: uppercase;
      h3 {
        font-size: 1rem;
        font-weight: 600;
      }
    }
  }

  .navbar-action-grid {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    li {
      &:not(:last-child) {
        margin-right: 15px;
      }
      .new-case-button {
        button {
          min-height: 30px;
          padding: 8px 10px;
          color: #273480;
          font-weight: 500;
          background: rgba(199, 208, 248, 0.4);
          border: none;
          border-radius: 5px;

          span {
            &:nth-child(1) {
              display: flex;
              align-items: center;
              img {
                width: 15px;
              }
            }
          }
          .plus-icon {
            margin-right: 7px;
          }
        }
      }
      .scan-qr-button {
        button {
          min-height: 30px;
          padding: 5px 15px;
          color: #ffffff;
          font-weight: 400;
          background: linear-gradient(90deg, #273480 0%, #bf1b39 100%);
          border: none;
          border-radius: 6.34px;
        }
      }
      .global-search {
        min-height: 32px;
        height: 32px;
        padding: 5px 10px;
        background: #bf1b39;
        font-weight: 500;
        color: #ffffff;
        border: none;
        text-transform: uppercase;
        border-radius: 6.4px;
        transition: all 0.2s ease-in-out;
        .global-search-d-flex {
          display: flex;
          align-items: center;
        }
        img {
          width: 14px;
        }

        .inactive {
          display: block;
          transition: all 2s ease-in-out;
        }
        &:hover {
          color: #ffff;
          background: #273480;
          transition: all 0.2s ease-in-out;
        }
      }
      .profile-dropdown,
      .notification-block {
        margin-bottom: -8px;
        .el-button {
          min-height: auto;
          padding: 0;
          background: none;
          border: none;
          .el-avatar {
            width: 32px !important;
            height: 32px !important;
            margin-bottom: 1px;
            border-radius: 50%;
            img {
              width: 100%;

              object-fit: cover;
            }
          }
        }
      }
    }
  }
}
.quick-navigation {
  z-index: 999;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  @media (min-width: 1200px) and (max-width: 1500px) {
    justify-content: center;
    padding: 0 10px;
  }
  a {
    display: block;
    padding: 5px;
    color: #888383;
    font-size: 14.5px;
    font-weight: 500;
    transition: all 0.2s ease-in-out;
    @media (min-width: 1200px) and (max-width: 1700px) {
      padding: 5px;
      font-size: 0.9em !important;
      font-size: 13px;
    }
    &:not(:last-child) {
      margin-right: 25px;
      @media (min-width: 1200px) and (max-width: 1700px) {
        margin-right: 15px;
      }
    }
    &:hover {
      color: #273480;
    }
  }
  .global-search-d-flex {
    display: flex;
    align-items: center;
  }
  img {
    width: 12px;
    position: relative;
    top: 2px;
  }
}
#top-navbar-view {
  box-sizing: border-box;
  .quick-navigation {
    padding-bottom: 12px;
    ul {
      display: flex;
      align-items: center;
      overflow-x: auto;
      justify-content: center;
      li {
        &:not(:last-child) {
          margin-right: 15px;
          @media (min-width: 1200px) and (max-width: 1440px) {
            margin-right: 10px;
          }
        }
        a {
          font-size: 12px !important;
          text-transform: uppercase;
          color: #000;
          font-weight: 500;
          background: #eef2f5;
          padding: 2px 15px;
          border-radius: 30px;
          border: 1px solid rgb(209 219 227);
          white-space: nowrap;
          @media (min-width: 1200px) and (max-width: 1440px) {
            padding: 2px 8px;
          }
          &.bg-blue {
            color: #ffff;
            background: #273480;
          }
          &.router-link-active {
            background: #bf1b39;
            color: #fff;
            /* box-shadow: 0 0 1px 1px #bf1b39; */
          }
          &.active {
            background: #bf1b39;
            color: #fff;
            /* box-shadow: 0 0 1px 1px #bf1b39; */
          }
          @media (min-width: 1200px) and (max-width: 1500px) {
            padding: 2px 7px;
          }
        }
      }
    }
  }

  .top-navbar-view-inner {
    .left-nav {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .logo {
        img {
          width: 150px;
        }
      }
      menu {
        position: relative;
        top: 3px;
      }
    }
    .center-nav {
      .nav-center-block {
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 45px;
        max-height: 100%;
        padding: 0 10px;
        h3 {
          color: #0a5da6;
          font-size: 16px;
          font-weight: 900;
        }
      }
    }
    .right-nav {
      display: flex;
      justify-content: flex-end;

      .block {
        position: relative;
        top: 11px;
        margin: 0 1.5em 0 0.5em;
      }
      .avatar {
        .el-button {
          padding: 0;
          border: none;
          &:hover {
            background-color: transparent;
          }
        }
      }
    }
  }
}
#navigation-toggle {
  .el-drawer__body {
    padding: 0;
  }
  @mixin search-bar {
    height: 38px;
    border-radius: 20px;
  }
  .menu-inner-view {
    padding: 5px 30px 7px 30px;
    background: #fff;
    border-bottom: 1px solid #e0e0e0;
    .menu-logo {
      display: flex;
      justify-content: space-around;
      .logo {
        padding: 0 2rem;
      }
    }
    .menu-search {
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
      h2 {
        padding: 9px 14px;
        color: #0a5da6;
        font-size: 16px;
        font-weight: 600;
      }
    }
  }
  .form-group {
    display: flex;
    width: 25%;

    span {
      position: relative;
      top: 5px;
      right: 32px;
      width: 30px;
      border-radius: 50%;
    }

    .el-input--suffix .el-input__inner {
      @include search-bar;
    }
  }
  .el-drawer__header {
    display: none;
  }
  .drawer-close-button {
    padding: 0 10px;
    text-align: end;
    display: flex;
    justify-content: flex-end;
    .el-button {
      padding: 0;
      border: none;
      &:active:hover {
        background: transparent;
      }
    }
  }
}

// profile
.el-dropdown__popper.el-popper[role="tooltip"] {
  position: absolute;
  top: 59.3333px;
  left: 1266px;
  z-index: 2129;
  margin: 0;
}
.login-profile {
  border: 1px solid rgb(86, 204, 242) !important;
  border-radius: 5px;
}
#profile {
  // padding-top: 5px;
  .profile-pop {
    max-width: 180px;
    height: 25px;
    padding: 0px 5px;
    text-align: center;
    background-color: white;
    border: none;
    border-radius: 10px;
    .profile-image {
      img {
        width: 90px;
        height: 100px;
      }
    }

    .edit-icon {
      img {
        position: relative;
        top: -14px;
        left: 1px;
        width: 21px;
        height: 18px;
      }
    }
    .profile-content {
      display: block;
      margin-top: -13px;
      line-height: 20px;
      &:hover {
        background-color: #fff;
      }
      h3 {
        color: #4f4f4f;
        font-size: 17px;
        font-weight: 500;
      }
      p {
        color: #828282;
        font-size: 14px;
        font-weight: 500;
      }
    }
    .username {
      padding: 0 5px;
      .el-button {
        width: 100%;
        min-height: 0px;
        padding: 0px 10px;
        margin: 0;
        border: none;
        &:hover,
        &:focus {
          background-color: white;
        }
      }
      ul {
        display: flex;
        justify-content: space-between;
        align-items: center;
        li {
          display: flex;
          align-items: center;
          h4 {
            margin-left: 12px;
            color: #4f4f4f;
            font-size: 14px;
          }
        }
      }
      .log-out {
        margin-left: 1px;
      }
    }
    .password {
      .el-button {
        min-height: 30px;
        :hover {
          background-color: white;
        }
        li {
          display: flex;
          align-items: center;
          padding: 0;
          margin: 5px;
        }
        .log-out {
          padding-right: 68px;
        }
        h4 {
          color: #4f4f4f;
          font-size: 14px;

          .log-out {
            padding-left: 20px;
          }

          img {
            margin: 0 9px -4px -1px;
          }
        }
      }
    }
  }
  .dropdown-profile-img {
    .el-avatar > img {
      width: 100% !important;

      object-fit: cover;
    }
  }
}

.location_grid {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .el-select {
    height: 30px;
    margin: 0px 0px 10px;
    .el-input__inner {
      height: 30px;
      box-shadow: none;
      padding-left: 10px;
      font-weight: 500;
      color: #000;
      font-size: 11px !important;
      background: #fff;
      padding: 2px 10px;
      border-radius: 10px;
      border: 0.640567px solid #2d9cdb;
      white-space: nowrap;
    }
    .select-trigger {
      width: 200px;
    }

    .el-input__suffix {
      background: transparent;
      border-radius: 0 5px 5px 0;
      right: 3px;
      top: 1px;
      height: 98%;

      .el-icon {
        color: #000 !important;
        font-weight: 800;
      }
    }
  }
}
// notification//
.notification-block {
  .el-badge__content.is-fixed {
    position: absolute;
    right: 24px;
    top: 8px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #273480;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    height: 20px;
    border-radius: 50%;
    padding: 0;
  }
  .el-button {
    margin: 0 6px;
    border: none;
    padding: 0;
    &:hover,
    &:focus {
      background-color: white;
      border: #e5e5e5;
    }
  }
  .el-dropdown-menu__item {
    background-color: red;
  }
}
.head {
  ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 14px;
    background-color: #c7d0f826;
    li {
      h4 {
        font-size: 14px;
        img {
          margin-right: 10px;
          margin-bottom: -3px;
        }
        p {
          line-height: 17px;
        }
      }
    }
  }
}
.each-notification-block {
  max-height: 200px;
  min-width: 250px;
  max-width: 300px;
  overflow: auto;
  padding-bottom: 5px;
}

.notification-dropdown-menu {
  padding: 1px !important;
  border: none !important;

  .el-dropdown-menu__item:not(:last-child) {
    line-height: 32px;
  }

  .el-dropdown-menu__item {
    color: #000;
    margin: 5px;
    border-radius: 7px;
    font-weight: 500 !important;
    background: #ffffff;
    border: 0.5px solid rgba(86, 204, 242, 0.8);
    height: 34px;
    transition: 0.5s;
    padding: 0;
    h4 {
      font-size: 12px;
      padding: 5px 15px;
      position: relative;
      line-height: 16px;
      max-height: 36px;
      &::after {
        content: "•";
        position: absolute;
        color: #273480;
        left: 1px;
        top: 4px;
        font-size: 30px;
      }
    }
    &.is-disabled {
      padding: 0 15px !important;
      line-height: 32px;
    }
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    color: #000 !important;
    font-weight: 500 !important;
    background: #eef2f5 !important;
    transition: 0.5s;
  }
}

.block {
  .el-popper__arrow::before {
    box-sizing: none;
    width: 0;
    height: 0;
  }
}
.value {
  text-transform: capitalize;
}
.notification-no-data {
  text-align: center;
  img {
    width: 125px;
    height: 125px;
  }
  .notify-para {
    color: #273480;
    font-weight: 500;
    padding: 10px 0;
    font-size: 16px;
  }
}
</style>
